import Vue from "vue";
import ElementUI from "element-ui";
import "../element-variables.scss";
import locale from "element-ui/lib/locale/lang/en";

Vue.use(ElementUI, { locale });
